/**
 * A form that is already on its way to the server is not sent again: a double
 * click or an impatient second click on "Send" / "Accept" / "Pay" would
 * otherwise create a second quote, booking or payment.
 *
 * Only real page submissions are held. Skipped: GET forms (filters, search),
 * forms opening in another tab, forms marked data-allow-resubmit, and submits
 * a page script already cancelled (AJAX forms). The form is released after
 * 15 seconds, or when the page is shown again from the back/forward cache.
 */
const RELEASE_AFTER_MS = 15000;

function release(form) {
    delete form.dataset.submitting;
    form.removeAttribute('aria-busy');
    form.querySelectorAll('[data-submit-once-disabled]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('data-submit-once-disabled');
    });
}

export function preventDoubleSubmit() {
    document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || event.defaultPrevented) {
            return;
        }
        const method = (form.getAttribute('method') || 'get').toLowerCase();
        if (method === 'get' || form.target === '_blank' || form.hasAttribute('data-allow-resubmit')) {
            return;
        }

        if (form.dataset.submitting === 'true') {
            event.preventDefault();
            return;
        }

        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        // After the browser has read the clicked button's name and value.
        setTimeout(() => {
            form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]').forEach((button) => {
                if (!button.disabled) {
                    button.disabled = true;
                    button.setAttribute('data-submit-once-disabled', '');
                }
            });
        }, 0);
        setTimeout(() => release(form), RELEASE_AFTER_MS);
    });

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            document.querySelectorAll('form[data-submitting]').forEach(release);
        }
    });
}
